import React from "react";
import PropTypes from "prop-types";
import HelperText from "../../../../../components/atoms/HelperText";
import NumberToPrecision from "../../../../../components/atoms/NumberToPrecision/NumberToPrecision";
import GnomadEntry from "../GnomadEntry";

function LOFProbabilityTable({ gnomadEntry }) {
  return (
    <table className="varsome-table tw-break-words tw-my-12">
      <thead>
        <tr>
          <th className="tw-text-center">
            Probability LOF Intolerant (pLI)
            <HelperText fieldDescriptionKey="Probability LOF Intolerant" />
          </th>
          <th className="tw-text-center">
            Probability LOF Recessive
            <HelperText fieldDescriptionKey="Probability LOF Recessive" />
          </th>
          <th className="tw-text-center">
            Probability LOF Tolerant
            <HelperText fieldDescriptionKey="Probability LOF Tolerant" />
          </th>
        </tr>
      </thead>
      <tbody className="varsome-text-center">
        <tr>
          <td>
            <NumberToPrecision
              value={gnomadEntry.pli * 100}
              digits={4}
              suffix="%"
            />
          </td>
          <td>
            <NumberToPrecision
              value={gnomadEntry.prec * 100}
              digits={4}
              suffix="%"
            />
          </td>
          <td>
            <NumberToPrecision
              value={gnomadEntry.pnull * 100}
              digits={4}
              suffix="%"
            />
          </td>
        </tr>
      </tbody>
    </table>
  );
}

LOFProbabilityTable.propTypes = {
  gnomadEntry: PropTypes.instanceOf(GnomadEntry),
};

LOFProbabilityTable.defaultProps = {
  gnomadEntry: null,
};

export default React.memo(LOFProbabilityTable);
